import { useState, useEffect } from 'react';
import { getSiteAppUserList } from 'services/users/usersList';
import { useDispatch } from 'react-redux';
import { showError } from '../../../../../redux/common/actions';
import { getLocalStorageData } from 'helpers/utils';
import { SHOW_ALL_OPTION } from '../../constants';

export const useUsers = (showAll = true) => {
  const dispatch = useDispatch();
  const [users, setUsers] = useState([]);
  const { siteAppID, userId, firstName, lastName } = getLocalStorageData("me");

  useEffect(() => {
    const loadUsers = async () => {
      try {
        const response = await getSiteAppUserList(siteAppID, 1, 1000); // Get all users
        if (response.status) {
          const fetchedUsers = response.data.map(user => ({
            id: user.id,
            name: `${user.lastName}, ${user.firstName}`,
            firstName: user.firstName,
            lastName: user.lastName
          }));
          
          let processedUsers = [];
          
          if (showAll) {
            processedUsers.push(SHOW_ALL_OPTION);
          }
          
          // Add "Current User" option
          processedUsers.push({ 
            id: userId, 
            name: "Current User",
            isCurrentUser: true
          });
          
          // Add all other users
          processedUsers.push(...fetchedUsers);
          
          setUsers(processedUsers);
        }
      } catch (error) {
        dispatch(
          showError(
            error?.response?.data?.detail || 'Failed to fetch users'
          )
        );
      }
    };

    if (siteAppID) {
      loadUsers();
    }
  }, [siteAppID, showAll, dispatch, userId]);

  return users;
}; 
